import i18n from '@/i18n';

import type { OpsPublishOption } from '.';

export const SCIENCE_CATALOGUE_OPTIONS: OpsPublishOption[] = [
  {
    get label() {
      return i18n.t('data-center:ops.option.life.sciences');
    },
    value: 'life.sciences',
    children: [
      {
        get label() {
          return i18n.t('data-center:ops.option.medicine');
        },
        value: 'medicine',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.rna');
        },
        value: 'rna',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.dna');
        },
        value: 'dna',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.protein');
        },
        value: 'protein',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.healthcare');
        },
        value: 'healthcare',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.biology');
        },
        value: 'biology',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.organs');
        },
        value: 'organs',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.molecules');
        },
        value: 'molecules',
      },
    ],
  },
  {
    get label() {
      return i18n.t('data-center:ops.option.materials.science');
    },
    value: 'materials.science',
    children: [
      {
        get label() {
          return i18n.t('data-center:ops.option.molecular.structure');
        },
        value: 'molecular.structure',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.material.structure');
        },
        value: 'material.structure',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.chemical.reactions');
        },
        value: 'chemical.reactions',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.organic.molecules');
        },
        value: 'organic.molecules',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.scientific.computing');
        },
        value: 'scientific.computing',
      },
    ],
  },
  {
    get label() {
      return i18n.t('data-center:ops.option.earth.science');
    },
    value: 'earth.science',
    children: [
      {
        get label() {
          return i18n.t('data-center:ops.option.prediction');
        },
        value: 'prediction',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.analysis');
        },
        value: 'analysis',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.energy.and.power');
        },
        value: 'energy.and.power',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.observation');
        },
        value: 'observation',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.remote.sensing');
        },
        value: 'remote.sensing',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.astronomy');
        },
        value: 'astronomy',
      },
    ],
  },
  {
    get label() {
      return i18n.t('data-center:ops.option.social.sciences');
    },
    value: 'social.sciences',
    children: [
      {
        get label() {
          return i18n.t('data-center:ops.option.history');
        },
        value: 'history',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.law');
        },
        value: 'law',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.economics.and.finance');
        },
        value: 'economics.and.finance',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.public.sentiment');
        },
        value: 'public.sentiment',
      },
    ],
  },
  {
    get label() {
      return i18n.t('data-center:ops.option.general.discipline');
    },
    value: 'general.discipline',
    children: [],
  },
  {
    get label() {
      return i18n.t('data-center:ops.option.physics');
    },
    value: 'physics',
    children: [
      {
        get label() {
          return i18n.t('data-center:ops.option.computational.physics');
        },
        value: 'computational.physics',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.fluid.mechanics');
        },
        value: 'fluid.mechanics',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.solid.mechanics');
        },
        value: 'solid.mechanics',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.electromagnetism');
        },
        value: 'electromagnetism',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.condensed.matter.physics');
        },
        value: 'condensed.matter.physics',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.astrophysics');
        },
        value: 'astrophysics',
      },
    ],
  },
];
